import { SelectPassThrough } from 'primeng/select';

export const SelectTelekomPT: SelectPassThrough = {
    virtualScroller: {
        root: {
            style: {
                'minHeight': '10rem'
            }
        }
    },
    option: {
        class: 'focus-border'
    }
};
